import { f as t } from "./function-uncurry-this.js";
import { f as i } from "./fails.js";
import { s as e } from "./string-pad.js";
var s = e.start,
  r = RangeError,
  a = isFinite,
  n = Math.abs,
  o = Date.prototype,
  g = o.toISOString,
  h = t(o.getTime),
  u = t(o.getUTCDate),
  f = t(o.getUTCFullYear),
  l = t(o.getUTCHours),
  T = t(o.getUTCMilliseconds),
  c = t(o.getUTCMinutes),
  m = t(o.getUTCMonth),
  p = t(o.getUTCSeconds),
  C = i(function () {
    return "0385-07-25T07:06:39.999Z" != g.call(new Date(-5e13 - 1));
  }) || !i(function () {
    g.call(new Date(NaN));
  }) ? function () {
    if (!a(h(this))) throw r("Invalid time value");
    var t = f(this),
      i = T(this),
      e = t < 0 ? "-" : t > 9999 ? "+" : "";
    return e + s(n(t), e ? 6 : 4, 0) + "-" + s(m(this) + 1, 2, 0) + "-" + s(u(this), 2, 0) + "T" + s(l(this), 2, 0) + ":" + s(c(this), 2, 0) + ":" + s(p(this), 2, 0) + "." + s(i, 3, 0) + "Z";
  } : g;
export { C as d };